import styled, { createGlobalStyle, css } from 'styled-components'
import 'react-toastify/dist/ReactToastify.css'

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
  }
  body, button, input, select, textarea {
    font-family: 'Montserrat', sans-serif;
  }
  @media (max-width: 1800px) {
    html {
      font-size: 93.75%;
    }
  }
  @media (max-width: 720px) {
    html {
      font-size: 87.5%;
    }
  }

  a {
    text-decoration: none;
  }
  li {
    list-style: none;
  }

  select {
    color: #000000 !important;
    background-color: #ffffff !important;
  }

  select option {
    color: #000000 !important;
    background-color: #ffffff !important;
  }
  
  body .Toastify .Toastify__toast-container .Toastify__toast--success {
    background: rgba(255, 255, 255, 1);
    color: #001843;
    font-weight: bold;
    font-size: 15pt;
    position: 'top-right',
  }
  body .Toastify .Toastify__toast-container .Toastify__toast--error {
    background: rgba(255, 255, 255, 1);
    color: #ed5247;
    font-weight: bold;
    font-size: 15pt;
    position: 'top-center',
  }


  html, body {
    background-color: ${(props) => props.theme.background};
    color: ${(props) => props.theme.textPrimary};
    scrollbar-color: #334155 rgba(15, 23, 42, 0.6);
    transition: background-color 0.25s ease, color 0.25s ease;
  }

  /* Ajustes globais de contraste para o Tema Claro */
  ${({ theme }) =>
    theme.name === 'light' &&
    css`
      div[class*='TitleGroup'] > h2,
      div[class*='TitleSection'] > h2,
      header[class*='CoverageHeader'] > h2 {
        color: #0f172a !important;
      }
      div[class*='TitleGroup'] > p,
      div[class*='TitleSection'] > p,
      header[class*='CoverageHeader'] > p {
        color: #475569 !important;
      }
    `}

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(15, 23, 42, 0.6);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #334155;
    border-radius: 4px;
    transition: background 0.2s;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #64748b;
  }
`
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgb(0, 24, 66);
  overflow: hidden;
  padding: 100px;

  .loading-icon {
    opacity: 0;
    animation: loading infinite 1s;
  }

  @keyframes loading {
    0% {
      opacity: 1;
      width: 34%;
    }

    100% {
      opacity: 1;
      width: 30%;
    }
  }
`
